module.exports = __webpack_public_path__ + "media/images/icons/filled/minus-circle-0e0b2669d88c5f023cb01f191ba3fd9d.svg";